<div>
    <h2 class="heading-2">Beschikbare producten voor {{ selectedServiceInfo?.title }}</h2>
    <aeg-datatable :value="filteredItems">
        <Column header="Productcode" :field="(item) => (`${item.productCode}${ item.variant ? ' - ' + item.variant : ''}`)" />
        <Column header="Productbeschrijving" field="productDescription" />
        <Column header="Eenheidsprijs" :field="(item) => formatCurrency(item.priceExclVat)" />
        <Column header="Btw-tarief" field="vatPercentage" />
        <Column>
            <template #body="slotProps">
                <Button
                    @click="addItemToBasket(slotProps.data)"
                    text rounded
                    icon="pi pi-cart-plus"
                    size="large"
                    style="padding:0;"
                    aria-label="Toevoegen aan winkelmandje"
                /><!-- Wouter: workaround for default button padding blowing up the table row height + needs tooltip -->
            </template>
        </Column>
        <Column v-if="isVip">
            <template #body="slotProps">
                <Button
                    @click="addItemToBasketAsDiscount(slotProps.data)"
                    text rounded
                    icon="pi pi-cart-minus"
                    size="large"
                    style="padding:0;"
                    aria-label="Toevoegen aan winkelmandje als korting"

                /><!-- Wouter: workaround for default button padding blowing up the table row height + needs tooltip -->
            </template>
        </Column>
    </aeg-datatable>
</div>
